export const formatNumber = (number: number, language: string, maximumFractionDigits = 2) => {
  const notation = String(number).includes('e') || number > 9999999999 ? 'scientific' : undefined
  return new Intl.NumberFormat(language, {maximumFractionDigits, notation}).format(number)
}

export const formatKpiValue = (value: string | undefined, language: string): string | undefined => {
  const parsedValue = parseFloat(value ?? '')

  return !isNaN(parsedValue) ? formatNumber(parsedValue, language) : undefined
}
